import { Effect } from "effect";

type Operation = (...args: Array<unknown>) => unknown;
type Define = (...definition: ReadonlyArray<unknown>) => Operation;

/** The SDK still receives the complete, unchanged diagnostic operation name.
 * Each operation becomes its `Effect.fn` on the first call: defining one
 * captures a stack trace, and the hundreds of catalogue entries evaluated at
 * module load made that capture a large share of the Worker's startup CPU. */
export const domainOperations = (domain: string) => (name: string): Effect.fn.Traced =>
  ((...definition: ReadonlyArray<unknown>) => {
    let operation: Operation | undefined;
    const lazy = function (this: unknown, ...args: Array<unknown>) {
      operation ??= (Effect.fn(domain + "." + name) as unknown as Define)(...definition);
      return operation.apply(this, args);
    };
    // Effect.fn reports the body's arity; with `{ self }` first, the body follows it.
    const body = definition.find(value => typeof value === "function");
    return Object.defineProperty(lazy, "length", { value: typeof body === "function" ? body.length : 0, configurable: true });
  }) as unknown as Effect.fn.Traced;
